import { Skeleton, Tabs } from "antd";
import AppPages from "navigation/AppPages";
import { Suspense, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

interface TabItem {
  name: string;
  path: string;
  componentName: string;
  code: string;
}

interface TabContainerProps {
  subMenu: TabItem[];
  centered?: boolean;
  className?: string;
}

const TabContainer: React.FC<TabContainerProps> = ({
  subMenu,
  centered = false,
  className,
}) => {
  const { pathname } = useLocation();
  const navigate = useNavigate();

  const [activeKey, setActiveKey] = useState<string>();

  const items = subMenu.map((item) => {
    const Component = AppPages.getPage(item.componentName);
    return {
      key: item.path,
      label: item.name,
      children: (
        <Suspense fallback={<Skeleton active />}>
          <Component code={item.code} />
        </Suspense>
      ),
    };
  });

  useEffect(() => {
    const found = subMenu.find((t) => pathname.includes(t.path));
    if (found) {
      setActiveKey(found.path);
    } else {
      setActiveKey(subMenu[0]?.path);
    }
  }, [pathname, subMenu]);

  const onChange = (key: string) => {
    setActiveKey(key);

    const basePath = pathname.split("/")[1];

    const cleanKey = key.replace("/", "");

    navigate(`/${basePath}/${cleanKey}`);
  };

  return (
    <div className="custom-tab">
      <Tabs
        centered={centered}
        style={{ backgroundColor: "white" }}
        activeKey={activeKey}
        items={items}
        onChange={onChange}
      />
    </div>
  );
};

export default TabContainer;
